<glxy-confirmation-body>
  <glxy-confirmation-title>
    {{ 'YESWARE.SELECT_YESWARE_CAMPAIGN_MODAL.TITLE' | translate }}
  </glxy-confirmation-title>
  <glxy-confirmation-custom-content>
    @if (isLoading) {
      <div class="loading-container">
        <glxy-loading-spinner></glxy-loading-spinner>
      </div>
    } @else if (options.length === 0) {
      <div class="no-campaigns-message">
        {{ 'YESWARE.SELECT_YESWARE_CAMPAIGN_MODAL.NO_CAMPAIGNS' | translate }}
      </div>
    } @else {
      <form>
        <glxy-form-field suffixIcon="arrow_drop_down">
          <glxy-label>
            {{ 'YESWARE.SELECT_YESWARE_CAMPAIGN_MODAL.SELECT_YESWARE_CAMPAIGN_LABEL' | translate }}
          </glxy-label>
          <input
            #input
            type="text"
            [placeholder]="'YESWARE.SELECT_YESWARE_CAMPAIGN_MODAL.SELECT_YESWARE_CAMPAIGN_PLACEHOLDER' | translate"
            matInput
            [formControl]="selectedListControl"
            [matAutocomplete]="auto"
            (input)="optionValues()"
            (focus)="optionValues()"
          />
          <mat-autocomplete [requireSelection]="true" #auto="matAutocomplete" [displayWith]="displayFn(options)">
            @for (option of options; track option) {
              <mat-option [value]="option.campaignId">{{ option.name }}</mat-option>
            }
          </mat-autocomplete>
          @if (!selectedListControl.untouched && selectedListControl.hasError('required')) {
            <glxy-error>
              {{ 'YESWARE.SELECT_YESWARE_CAMPAIGN_MODAL.SELECT_YESWARE_CAMPAIGN_REQUIRED' | translate }}
            </glxy-error>
          }
        </glxy-form-field>
      </form>
    }
  </glxy-confirmation-custom-content>
</glxy-confirmation-body>

<glxy-confirmation-actions>
  <glxy-confirmation-primary-actions>
    <div
      class="number-of-rows-selected"
      [innerHTML]="
        'YESWARE.SELECT_YESWARE_CAMPAIGN_MODAL.AMOUNT_OF_SELECTED_CONTACTS'
          | translate: { amount: numberOfRows }
          | iTrustThisHtml
      "
    ></div>
    <button mat-stroked-button matDialogClose>
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>

    <button mat-flat-button color="primary" (click)="addToCampaign()" [disabled]="options.length === 0">
      {{ 'ACTIONS.ADD' | translate }}
    </button>
  </glxy-confirmation-primary-actions>
</glxy-confirmation-actions>
